import {
  LotterySchema,
  PartyUidSchema,
  RetailUnitSchema,
} from '@lotta/shared/types-lottery-schemas';
import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type DeleteParticipantsParams = Static<typeof DeleteParticipantsParamsSchema>;
export const DeleteParticipantsParamsSchema = Type.Object(
  {
    retailUnit: RetailUnitSchema.properties.id,
    lotteryId: LotterySchema.properties.id,
  },
  { additionalProperties: false, $id: 'DeleteParticipantsParamsSchema' }
);

export type DeleteParticipantsBody = Static<typeof DeleteParticipantsBodySchema>;
export const DeleteParticipantsBodySchema = Type.Object(
  {
    participant: Type.Object(
      {
        partyUid: PartyUidSchema,
        entryDate: Type.String({ format: 'date' }),
      },
      { additionalProperties: false }
    ),
  },
  {
    additionalProperties: false,
    $id: 'DeleteParticipantsBodySchema',
  }
);

export type DeleteParticipantsResponse = Static<typeof DeleteParticipantsResponseSchema>;
export const DeleteParticipantsResponseSchema = Type.Literal('', {
  $id: 'DeleteParticipantsResponseSchema',
});
